import { render } from "./videoModal.vue?vue&type=template&id=77c49aa4&scoped=true"
import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"

import "./videoModal.vue?vue&type=style&index=0&id=77c49aa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c49aa4"]])

export default __exports__